export default {
	candidateSummarySideMenuOpen({ commit }, status) {
        commit('setCandidateSummarySideMenuOpen', status)
    },
}